import React from "react";
import { AnouncementProvider } from "./contexts/announcement-context/AnnouncementContext";
import { AppProvider } from "./contexts/app-context/AppContext";
import { ApplicationsProvider } from "./contexts/applications-context/ApplicationsContext";
import { GlobelFilterProvider } from "./contexts/globel-filter-context/GlobelFilterContext";
import { TeamsProvider } from "./contexts/teams-context/TeamsContext";
import { UserProvider } from "./contexts/user-context/UserContext";
import { WorkshopsProvider } from "./contexts/workshops-context/WorkshopsContext";
import { YearProvider } from "./contexts/year-context/YearContext";

interface IProps {
  children: any;
}

const AppProviders = (props: IProps) => {
  return (
    <AppProvider>
      <UserProvider>
        <YearProvider>
          <ApplicationsProvider>
            <AnouncementProvider>
              <TeamsProvider>
              <WorkshopsProvider>
                <GlobelFilterProvider>{props.children}</GlobelFilterProvider>
              </WorkshopsProvider>
              </TeamsProvider>
            </AnouncementProvider>
          </ApplicationsProvider>
        </YearProvider>
      </UserProvider>
    </AppProvider>
  );
};

export default AppProviders;
